import script from "./UserStatsCards.vue?vue&type=script&setup=true&lang=js"
export * from "./UserStatsCards.vue?vue&type=script&setup=true&lang=js"

import "./UserStatsCards.vue?vue&type=style&index=0&id=7c06925c&scoped=true&lang=css"
import "./UserStatsCards.vue?vue&type=style&index=1&id=7c06925c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c06925c"]])

export default __exports__